import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { spacing, styled, useThemeProps } from '../../../foundation';
import { RcDivider } from '../../Divider';
var _RcVirtualizedDivider = forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: 'RcVirtualizedDivider',
    });
    var className = props.className, rest = __rest(props, ["className"]);
    return (React.createElement("li", { className: className, "data-disabled-focus": true },
        React.createElement(RcDivider, __assign({}, rest, { ref: ref }))));
});
/**
 * that virtualized divider is same as normal divider,
 * but that use a `li` to wrap outside,
 * use padding inside to prevent dynamic container height error calculate
 * and make that not be focusable
 */
var RcVirtualizedDivider = styled(_RcVirtualizedDivider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  list-style: none;\n"], ["\n  padding: ", ";\n  list-style: none;\n"])), spacing(2, 0));
RcVirtualizedDivider.defaultProps = {};
RcVirtualizedDivider.displayName = 'RcVirtualizedDivider';
export { RcVirtualizedDivider };
var templateObject_1;
